import { spaceTypeOptions } from "components/constants/DropdownOptions";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const TopBarCard = ({ item }) => {
  const { t } = useTranslation();

  return (
    <Col lg={4}>
      <div className="inner_section">
        <Row className="align-items-end">
          <Col md={5}>
            <h2 className="fs_40 text-center">
              {item.averageRating?.toFixed(2) || "-"}
            </h2>
            <p className="fs_12 text-center text_gray">{t("Average Rating")}</p>
          </Col>
          <Col md={7}>
            <h2 className="fs_20 mb-2">
              {t(
                spaceTypeOptions?.find(
                  (option) => option.value === item?.spaceType
                )?.name
              ) || "-"}
            </h2>
            <p className="fs_12 text_gray">
              {t("Total Ratings: ")} {item?.totalRatings || "-"}
            </p>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default TopBarCard;
